export default function scrollToTop() {

	const button = document.querySelector(".js-scroll-to-top")
	if (!button) return
	
	button.addEventListener("click", e => {
		e.preventDefault()
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
	})
}